export const GoldButton = ({ children, className = "", as = "a", ...props }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full bg-gold px-7 py-3.5 font-body font-semibold text-[15px] text-white transition-all duration-300 hover:bg-gold-dark hover:shadow-[0_8px_24px_rgba(184,134,46,0.28)] active:scale-[0.98] min-h-[48px]";
  const Comp = as;
  return (
    <Comp className={`${base} ${className}`} {...props}>
      {children}
    </Comp>
  );
};

export const DarkButton = ({ children, className = "", as = "a", ...props }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full bg-ink px-7 py-3.5 font-body font-semibold text-[15px] text-white transition-all duration-300 hover:bg-[#2b2b30] hover:shadow-[0_8px_24px_rgba(17,18,20,0.22)] active:scale-[0.98] min-h-[48px]";
  const Comp = as;
  return (
    <Comp className={`${base} ${className}`} {...props}>
      {children}
    </Comp>
  );
};

export const OutlineButton = ({
  children,
  className = "",
  as = "a",
  dark = false,
  ...props
}) => {
  const tone = dark
    ? "border-cream/25 text-cream hover:border-gold-light hover:text-gold-light"
    : "border-ink/20 text-ink hover:border-gold hover:text-gold";
  const base = `inline-flex items-center justify-center gap-2 rounded-full border px-7 py-3.5 font-body font-semibold text-[15px] transition-all duration-300 active:scale-[0.98] min-h-[48px] ${tone}`;
  const Comp = as;
  return (
    <Comp className={`${base} ${className}`} {...props}>
      {children}
    </Comp>
  );
};
